import React from 'react';
import { ScrollArea } from '../ui/scroll-area';
import { useImageProperties } from '../ImageNode';
import PanelHeader from './PanelHeader';
import DimensionsSection from './DimensionsSection';
import RotationSection from './RotationSection';
import StylesSection from './StylesSection';
import WrapSection from './WrapSection';
import AltTextSection from './AltTextSection';
import ActionsSection from './ActionsSection';

const PropertiesPanel = (props) => {
  const {
    selectedNodeIsImage,
    width,
    height,
    rotation,
    wrap,
    alt,
    copiedUrl,
    naturalWidth,
    naturalHeight,
    aspectRatioLocked,
    borderColor,
    borderWidth,
    borderStyle,
    borderRadius,
    opacity,
    MAX_CONTENT_WIDTH,
    MAX_CONTENT_HEIGHT,
    setAspectRatioLocked,
    handleWidthChange,
    handleHeightChange,
    handleRotationChange,
    handleRotateButton,
    handleWrapChange,
    handleAltChange,
    handleBorderColorChange,
    handleBorderWidthChange,
    handleBorderStyleChange,
    handleBorderRadiusChange,
    handleOpacityChange,
    handleCopyUrl,
    handleDelete,
    handleDownload,
    handleAddToGallery,
    startHoldIncrement,
    stopHoldIncrement,
    incrementWidth,
    decrementWidth,
    incrementHeight,
    decrementHeight,
  } = useImageProperties(props);

  if (!selectedNodeIsImage) {
    return null;
  }

  return (
    <div
      data-properties-panel
      className="h-full flex flex-col bg-white dark:bg-slate-900"
      // T-035.1: keep the editor's NodeSelection alive when the user clicks
      // buttons/sliders in the panel. Text inputs still need the caret, so only
      // preventDefault for non-text controls.
      onMouseDown={(e) => {
        const t = e.target.tagName;
        if (t !== 'INPUT' && t !== 'TEXTAREA' && t !== 'SELECT') e.preventDefault();
      }}
    >
      <PanelHeader onClose={props.onClose} />
      <ScrollArea className="flex-1 p-4">
        <div className="space-y-6 pr-4">
          <DimensionsSection
            width={width}
            height={height}
            naturalWidth={naturalWidth}
            naturalHeight={naturalHeight}
            aspectRatioLocked={aspectRatioLocked}
            onToggleAspectRatio={() => setAspectRatioLocked((prev) => !prev)}
            handleWidthChange={handleWidthChange}
            handleHeightChange={handleHeightChange}
            startHoldIncrement={startHoldIncrement}
            stopHoldIncrement={stopHoldIncrement}
            incrementWidth={incrementWidth}
            decrementWidth={decrementWidth}
            incrementHeight={incrementHeight}
            decrementHeight={decrementHeight}
            maxWidth={MAX_CONTENT_WIDTH}
            maxHeight={MAX_CONTENT_HEIGHT}
          />

          <RotationSection
            rotation={rotation}
            onChange={handleRotationChange}
            onRotate={handleRotateButton}
          />

          <StylesSection
            borderColor={borderColor}
            borderWidth={borderWidth}
            borderStyle={borderStyle}
            borderRadius={borderRadius}
            opacity={opacity}
            onBorderColorChange={handleBorderColorChange}
            onBorderWidthChange={handleBorderWidthChange}
            onBorderStyleChange={handleBorderStyleChange}
            onBorderRadiusChange={handleBorderRadiusChange}
            onOpacityChange={handleOpacityChange}
          />

          <WrapSection wrap={wrap} onWrapChange={handleWrapChange} />
          <AltTextSection alt={alt} onAltChange={handleAltChange} />
          <ActionsSection
            copiedUrl={copiedUrl}
            onCopyUrl={handleCopyUrl}
            onDownload={handleDownload}
            onAddToGallery={handleAddToGallery}
            onDelete={handleDelete}
          />
        </div>
      </ScrollArea>
    </div>
  );
};

export default PropertiesPanel;
